/**
 * Function to return year or years appended to the val passed in
 * @param {number} val
 * @returns
 */
export const formatYears = (val: number): string =>
  val <= 1 ? `${val} year` : `${val} years`;

/**
 * Function to return month or months appended to the val passed in
 * @param {number} val
 * @returns
 */
export const formatMonths = (val: number): string =>
  val <= 1 ? `${val} month` : `${val} months`;
